import { useTranslation } from "react-i18next";
import { AxiosResponse } from "axios";
import { axiosConfig } from "../../config/api/configApi";
import { axiosConfigV2 } from "../../config/api/configApiv2";

export const getRevokeEdxToken: (
  param: string
) => Promise<AxiosResponse<any>> = (param: string) => {
  return axiosConfig.get(`/authentications/revoke-openedx?token=${param}`);
};

export const getRevokeLogOut: (
  refreshToken: string
) => Promise<AxiosResponse<any>> = (refreshToken: string) => {
  return axiosConfig.get(`/authentications/revoke`, {
    headers: {
      Authorization: `Bearer ${refreshToken}`,
    },
  });
};

export const postLogout: (
) => Promise<AxiosResponse<any>> = () => {
  return axiosConfig.post(`/v2/auth/logout`);
};

export const exportCourseInfo: () => Promise<AxiosResponse<any>> = () => {
  return axiosConfigV2.get(`/mooc-courses/export-view-status-and-learning`, {responseType: 'arraybuffer'});
}
